import { getGeneralConstraints } from "#/config/orders";
import { useOpenOrders } from "#/store/wallet/account/openOrders";
import { type UnderlyingSymbol } from "#/types/markets";
import { getMarketByUnderlying } from "#/utils/marketPair";

export const useValidateMaxNumOfOrders = (
  underlying: UnderlyingSymbol,
  size: string,
  isLimit: boolean,
) => {
  const market = getMarketByUnderlying(underlying);
  const { openOrders } = useOpenOrders(market);
  const { maxNumberOfOrders } = getGeneralConstraints(underlying);

  return isLimit && Number(size) > 0 && openOrders.length >= maxNumberOfOrders
    ? `Max open orders reached. ${maxNumberOfOrders} open orders per market.`
    : "";
};
